import { useCallback, useEffect, useState } from 'react'

import { messageTypes } from './constants'

const useIframeTheme = () => {
  const [iframeTheme, setIframeTheme] = useState(null)

  const handleMessage = useCallback(event => {
    const { type, payload } = event.data || {}

    if (type === messageTypes.themeUpdate) {
      setIframeTheme(payload)
    }
  }, [])

  useEffect(() => {
    window.addEventListener('message', handleMessage)
    if (window.parent !== window) {
      window.parent.postMessage({ type: messageTypes.iframeReady }, '*') // nosemgrep: javascript.browser.security.wildcard-postmessage-configuration.wildcard-postmessage-configuration
    }
    return () => window.removeEventListener('message', handleMessage)
  }, [handleMessage])

  return { iframeTheme }
}

export default useIframeTheme
